import { getMessagesForConversation } from 'api/messages'
import { receiveMessagesForConversation } from 'modules/conversations/actions'
import { getActiveConversationId,getIsActiveConversationNew } from 'modules/conversations/selectors'
import { pathOr } from 'ramda'
import { useCallback } from 'react'
import { useDispatch,useSelector } from 'react-redux'
import { error } from 'utils'

interface FetchMessagesProps {
  limit?: number,
  from?: number | null
}

const useFetchActiveConverationMessages = () => {
  const dispatch = useDispatch()
  const activeConversationId = useSelector(getActiveConversationId)
  const isActiveConversationNew = useSelector(getIsActiveConversationNew)

  const fetchMessages = useCallback(async ({ limit = 30, from = null }: FetchMessagesProps) => {
    if (isActiveConversationNew) {
      return
    }

    try {
      const { data } = await getMessagesForConversation({
        conversationId: activeConversationId,
        limit,
        from
      })

      dispatch(receiveMessagesForConversation({
        messages: data.data,
        hasMoreMessages: pathOr(false, ['pagination', 'more'], data),
        nextPageMessageId: pathOr(null, ['pagination', 'next'], data),
        conversationId: activeConversationId
      }))

      return data
    } catch (err) {
      error(`Failed to fetch messages`, err)
    }
  }, [activeConversationId, dispatch, isActiveConversationNew])

  return { fetchMessages }
}

export default useFetchActiveConverationMessages
